import styled from '@emotion/styled';

export const OrgDetailWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem 0;
    border-bottom: 1px solid ${(props) => props.theme.input.background};
    margin: 0 0 1rem 0;
`;

export const OrgContentWrap = styled.div`
    padding: 0 1.5rem;
    width: 100%;
`;

export const OrgDetailItemsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;
